import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import icSettings from '@iconify/icons-ic/twotone-settings';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'vex-config-panel-toggle',
    templateUrl: './config-panel-toggle.component.html',
    styleUrls: ['./config-panel-toggle.component.scss'],
    standalone: false
})
export class ConfigPanelToggleComponent implements OnInit {

  @Output() openConfig = new EventEmitter();

  icSettings = icSettings;

  constructor() { }

  ngOnInit() {
  }

}
